<template lang="pug">
  y-dialog(v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card(flat)
      v-card-title.pa-4
        div.h6.primary500--text {{ $t('edit_postcode') }}
        v-spacer
        v-btn(color="transparent" icon small @click="showModal = !showModal")
          eva-icon.mt-1(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
      v-card-text.pa-4(v-if="address")
        .s1.danger--text(v-if="isInvalid") {{ $t('invalid_postcode_for_address') }}
        v-card.pa-4.my-2(flat outlined)
          .p2 {{ address.address_1 }}, {{ address.address_2 }}, 
            span(:class="isInvalid ? 'danger--text' : ''") {{ address.postcode }}
            span , {{ address.city }}, {{ address.state }}, {{ address.country }}
        v-row(align="center")
          v-col
            .p2 {{ $t('order') }}: {{ `#${lead.rid}` }}
            .p2 {{ $t('customer') }}: {{ address.name }}
            .p2 {{ $t('phone') }}: {{ address.phone }}
          v-col.shrink
            div.d-flex.mr-2(@click="contactReceiver()")
              v-icon(left small color="info500") mdi-whatsapp
              a.button-Aa-small.my-auto.info500--text(@click="editRecipientPostcodeDialog = true") {{ $t('contact') }}
        .label.text-uppercase.mt-4 {{ $t('new_postcode') }}
        v-text-field.mt-2(v-model="postcode" background-color="basic200" outlined dense height="40" hide-details="auto" :placeholder="$t('enter_valid_postcode_here')" :loading="isFetching" @keyup="fetchPostcodes(postcode)")
      v-card-actions.px-4.pb-4
        v-btn(color="success500" depressed height="40" @click="clickSave" :loading="isLoading" dark block :disabled="isInvalid" :dark="!isInvalid")
          .button-AA-medium.basic100--text.mx-2 {{ $t('save_changes') }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditPostcode',
  props: ['open', 'parentYezzaShipping', 'lead'],
  data: () => ({
    isLoading: false,
    isFetching: false,
    isInvalid: true,
    postcode: null,
    address: null,
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    yezzaShipping: {
      get () {
        return this.parentYezzaShipping
      },
      set (newValue) {
        this.$emit('update:parentYezzaShipping', newValue)
      }
    }
  },
  mounted () {
    this.postcode = this.yezzaShipping.receiver_address.postcode
    this.address = { ...this.yezzaShipping.receiver_address }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchPostcodes (val) {
      if (!val) {
        return
      }
      console.log(val.length)
      if (val.length !== 5) {
        return
      }
      console.log(val.length)
      this.isFetching = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.address, 'postcode', addresses[0].postcode)
          this.$set(this.address, 'city', addresses[0].city)
          this.$set(this.address, 'state', addresses[0].state)
          this.$set(this.address, 'country', addresses[0].country)
          this.isInvalid = false
          console.log('asdas')
        }
      }).catch(() => {})
      .finally(() => {
        this.isFetching = false
      })
    },
    clickSave () {
      this.isLoading = true
      this.axios.patch(`/leads/${this.lead.pid}/`, { shipping_address: this.address })
        .then(resp => {
          this.$emit('updated', resp.data)
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    contactReceiver () {
      window.open(`https://api.whatsapp.com/send?phone=${this.yezzaShipping.receiver_address.phone}`)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "edit_postcode": "Edit postcode",
    "new_psotcode": "new postcode",
    "invalid_postcode_for_address": "Invalid postcode for the following address",
    "enter_valid_postcode_here": "Enter a valid postcode here"
  },
  "id": {
    "edit_postcode": "Edit kode pos",
    "new_psotcode": "kode pos baru",
    "invalid_postcode_for_address": "Kode pos tidak valid untuk alamat berikut",
    "enter_valid_postcode_here": "Masukkan kode pos yang valid di sini"
  }
}
</i18n>